import { Component, contentChildren, input } from '@angular/core';
import { OptionComponent } from '../option/option.component';

@Component({
  selector: 'ui-optgroup',
  template: '<ng-content />',
})
export class OptgroupComponent {
  // Label displayed for the option group
  readonly label = input.required<string>();
  // Child ui-option components within this group
  readonly uiOptions = contentChildren(OptionComponent);
}
